import api from './index';

export default ({ appKey, platform, accessToken, autologinToken, authHistoryToken }) => {
  api.defaults.headers.common['X-App-Key'] = appKey;
  api.defaults.headers.common['X-Platform'] = platform;
  api.defaults.headers.common['X-Access-Token'] = accessToken;
  api.defaults.headers.common['X-Autologin-Token'] = autologinToken;
  api.defaults.headers.common['X-AuthHistory-Token'] = authHistoryToken;
};
